export enum PublicSiteState {
    Undefined,
    CompanyNotFound,
    MemberCodeNotFoundOrExpired,
    CompanyFound,
    MemberFoundByPasswordCode,
    AccountHasBeenActivated
}